import React from 'react';
import './RolePicker.css';
import useRevealOnScroll from '../utils/useRevealOnScroll';
import { FaMobileAlt, FaUtensils } from 'react-icons/fa';

export default function RolePicker({ onPick }) {
  const { ref, isVisible } = useRevealOnScroll({ rootMargin: '0px 0px -8% 0px' });

  return (
    <section className={isVisible ? 'section role reveal isVisible' : 'section role reveal'} ref={ref}>
      <div className="container">
        <div className="roleCard" id="choose">
          <div className="roleTitle">Choose your view</div>
          <div className="roleSubtitle">Pick one.</div>

          <div className="roleGrid">
            <button className="roleBtn" type="button" onClick={() => onPick('owner')}>
              <div className="roleBtnIcon" aria-hidden="true">
                <FaUtensils />
              </div>
              <div className="roleBtnLabel">I am a Restaurant Owner</div>
              <div className="roleBtnCta btn btnGhost" aria-hidden="true">Open</div>
            </button>

            <button className="roleBtn" type="button" onClick={() => onPick('customer')}>
              <div className="roleBtnIcon" aria-hidden="true">
                <FaMobileAlt />
              </div>
              <div className="roleBtnLabel">I am a Customer</div>
              <div className="roleBtnCta btn btnGhost" aria-hidden="true">Open</div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
